import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  max-width: 1440px;
  padding: 30px;
`;

export const Content = styled.div`
  max-width: 1440px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 40px;

  @media ${(props) => props.theme.screen.md} {
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    gap: 60px;
  }
`;

export const SupportContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 32px;

  @media ${(props) => props.theme.screen.md} {
    flex-direction: row;
    gap: 50px;
  }
`;

export const SupportText = styled.p`
  font-family: ${(props) => props.theme.fontFamilies.vollkorn};
  font-size: 16px;
  line-height: 110%;
  text-align: center;
  margin: 0;

  @media ${(props) => props.theme.screen.md} {
    max-width: 110px;
    text-align: left;
  }
`;

export const LogosContainer = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 24px;
  align-items: center;
  justify-items: center;
  width: 100%;
  max-width: 400px;

  @media ${(props) => props.theme.screen.md} {
    display: flex;
    flex-direction: row;
    gap: 48px;
    width: auto;
    max-width: none;
  }
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const Logo = styled.img`
  max-width: 120px;
  max-height: 60px;
  width: auto;
  height: auto;
  object-fit: contain;

  @media ${(props) => props.theme.device.laptop} {
    max-width: 150px;
    max-height: 70px;
  }
`;

export const TextOrganization = styled.span`
  font-family: ${(props) => props.theme.fontFamilies.sfPro};
  font-weight: 1000;
  font-size: 20px;
  color: ${(props) => props.theme.colors.black};

  max-width: 140px;

  @media ${(props) => props.theme.device.laptop} {
    font-size: 24px;
  }
`;
